import { PermDeviceInformation } from "@mui/icons-material";
import { useSelector } from "react-redux";
import { Alert, Button, ButtonGroup, Grid, Input, Textarea, Option, Select, Stack, Typography } from "@mui/joy";
import { useState } from "react";
import { server_url } from '../core/config_geral'
import { Link } from "react-router-dom";
import axios from "axios";

function NovaTrilhaPage() {

    var token = useSelector((state) => state.auth.token)
    const [state, setState] = useState({
        loading: false,
        information: "Enviar",
        error: null,
        descricao: null,
        titulo: null,
    })

    function updateAttribute(tag, valor) {
        setState(prev => ({
            ...prev,
            [tag]: valor
        }))
    }

    const registrarTrilha = async (titulo, descricao) => {
        const formData = new FormData();
        const formToSend = {
            action: "CASTOR_CRIAR_NOVA_TRILHA_RPC",
            runNow: true,
            payload: JSON.stringify({
                descricao: descricao,
                titulo: titulo
            }),
        };

        formData.append("file", null);
        formData.append(
            "data",
            new Blob([JSON.stringify(formToSend)], {
                type: "application/json",
            })
        );

        try {
            var r = await axios.post(server_url + "/rpc", formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    "Authorization": `Bearer ${token}`,
                }
            });

            return r;
        } catch (error) {
            console.log(error)
            return null;
        }
    }

    async function enviar() {

        setState(prev => ({
            ...prev,
            error: null,
            information: "Registrando...",
            loading: true
        }))

        var error = null;
        if (state.descricao == null || state.descricao.length == 0)
            error = "Descrição inválida";
        else if (state.titulo == null || state.titulo.length == 0)
            error = "Títutlo inválido";

        if (error != null)
            setState(prev => ({ ...prev, error, loading: false, information: "Enviar" }))
        else {
            setState(prev => ({ ...prev, information: "Registrando trilha..." }))

            setTimeout(() => {
                var r = registrarTrilha(state.titulo, state.descricao)

                setTimeout(() => {
                    if (r == null) {
                        setState(prev => ({
                            ...prev,
                            loading: false,
                            information: "Enviar",
                            error: "Erro ao registrar trilha (Vide Console)",
                        }))
                        console.log(r)
                    } else
                        setState(prev => ({
                            ...prev,
                            loading: false,
                            information: "Enviado!",
                            error: "SUCESSO!",
                        }))
                }, 500);
            }, 100)


        }
    }

    return <>
        <Grid xs={12}>
            <Stack spacing={1}>
                <Typography>
                    Cadastro de media
                </Typography>
                {state.error !== null && <Alert color="danger"> {state.error}</Alert>}
                <Input placeholder="Título" onChange={(e) => updateAttribute("titulo", e.target.value)}></Input>
                <Textarea minRows={10} placeholder="Descrição" onChange={(e) => updateAttribute("descricao", e.target.value)} />
                <Button onClick={enviar} disabled={state.loading}>{state.information}</Button>
            </Stack>
        </Grid> </>
}

export default NovaTrilhaPage;

